import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
// Styled-Components.
// -----------------------------------------------------------------------------
export const RadioGroupWrapper = styled.div `
  ${({ direction }) => {
    return css `
      display: inline-flex;
      flex-direction: ${direction};
      flex-wrap: wrap;
      gap: ${getSpace('m')};
    `;
}}
`;
//# sourceMappingURL=RadioGroup.styled.js.map